import Vue from 'vue'
import Konva from 'konva'

export default {
  data () {
    return {
      draw: true,
      mouseDown: false,
      drawing: {
        startPos: { x: '', y: '' },
        currentPos: { x: '', y: '' }
      },
      drawAttempt: false,
      showWarning: false,
      showNewMapping: false,
      tempLayer: null
    }
  },
  methods: {
    startDraw (posIn) {
      this.drawing.startPos.x = posIn.x / this.scaleScore
      this.drawing.startPos.y = posIn.y / this.scaleScore
      this.drawing.currentPos.x = posIn.x / this.scaleScore
      this.drawing.currentPos.y = posIn.y / this.scaleScore
    },
    updateDraw (posIn, selectionRect) {
      this.drawing.currentPos.x = posIn.x / this.scaleScore
      this.drawing.currentPos.y = posIn.y / this.scaleScore
      let posRect = this.selection()
      selectionRect.x(posRect.x1)
      selectionRect.y(posRect.y1)
      selectionRect.width(posRect.x2 - posRect.x1)
      selectionRect.height(posRect.y2 - posRect.y1)
      selectionRect.visible(true)
      this.stage.draw()
      this.draw = true
    },
    selection () {
      let startPosx = this.drawing.startPos.x
      let startPosy = this.drawing.startPos.y
      let currentPosx = this.drawing.currentPos.x
      let currentPosy = this.drawing.currentPos.y
      let distance

      if (startPosx > currentPosx) {
        distance = Math.abs(startPosx - currentPosx)
        startPosx = currentPosx
        currentPosx = startPosx + distance
      }
      if (startPosy > currentPosy) {
        distance = Math.abs(startPosy - currentPosy)
        startPosy = currentPosy
        currentPosy = startPosy + distance
      }
      return ({
        x1: startPosx,
        y1: startPosy,
        x2: currentPosx,
        y2: currentPosy
      })
    },
    resetSelectionRect (selectionRect) {
      selectionRect.setAttrs({
        x: 0,
        y: 0,
        width: 0,
        height: 0
      })
    },
    initDrawTool () {
      let vm = this
      vm.tempLayer = new Konva.Layer({ })

      let selectionRect = new Konva.Rect({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        stroke: vm.theme[vm.selectedTheme].strokeColor,
        dash: [6, 6]
      })
      selectionRect.listening(false)

      vm.tempLayer.add(selectionRect)
      vm.stage.add(vm.tempLayer)

      vm.baseRect.on('mousedown', function (e) {
        if (vm.draw) {
          vm.mouseDown = true
          vm.clearSelection()
        }
        vm.drawAttempt = true
        vm.startDraw(vm.stage.getPointerPosition())
      })

      vm.baseRect.on('mousemove', function (e) {
        if (vm.mouseDown === true) {
          vm.updateDraw(vm.stage.getPointerPosition(), selectionRect)
        } else if (vm.drawAttempt) {
          vm.showWarning = true
        }
      })

      vm.baseRect.on('mouseup', function (e) {
        if (vm.mouseDown) {
          vm.mouseDown = false
          selectionRect.visible(false)

          let temp = selectionRect.clone({
            id: 'new',
            name: 'crop_rect',
            edit_type: 'creating',
            template_id: vm.id,
            listening: true,
            draggable: true,
            dash: false
          })

          temp.visible(true)

          vm.resetSelectionRect(selectionRect)
          if (vm.draw === true && temp.attrs.width > 0) {
            let groupNodes = vm.groupsInGroup(temp)
            let shapeNodes = vm.shapesInGroup(temp)
            let groupChildren = groupNodes.concat(shapeNodes)
            if (groupChildren.length > 0) {
              vm.createNewGroup(temp)
              vm.groupChildren = groupChildren
              vm.showNewGrouping = true
            } else {
              vm.bindListeners(temp)
              vm.tempLayer.add(temp)
              vm.tempLayer.draw()
              vm.showNewMapping = true
            }
          }
          vm.mouseDown = false
        } else if (vm.showWarning) {
          Vue.toasted.show('Please enable draw before creating shapes...',
            { icon: 'chain-broken', type: 'info' })
          this.showWarning = false
          this.drawAttempt = false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/drawShape.js